"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var reactstrap_1 = require("reactstrap");
var Services_1 = require("../../Services");
var Endpoints_1 = require("../../Utils/Endpoints");
var PasswordResetStatus;
(function (PasswordResetStatus) {
    PasswordResetStatus[PasswordResetStatus["Error"] = 0] = "Error";
    PasswordResetStatus[PasswordResetStatus["Success"] = 1] = "Success";
    PasswordResetStatus[PasswordResetStatus["Canceled"] = 2] = "Canceled";
})(PasswordResetStatus || (PasswordResetStatus = {}));
var PasswordResetLanding = /** @class */ (function (_super) {
    __extends(PasswordResetLanding, _super);
    function PasswordResetLanding(props) {
        var _this = _super.call(this, props) || this;
        _this.title = function () {
            switch (_this.state.status) {
                case PasswordResetStatus.Error:
                    return _this.props.resources.Error + "!";
                case PasswordResetStatus.Canceled:
                    return _this.props.resources.Canceled + "!";
                case PasswordResetStatus.Success:
                    return _this.props.resources.Success + "!";
            }
        };
        _this.content = function () {
            switch (_this.state.status) {
                case PasswordResetStatus.Error:
                    return React.createElement("span", null,
                        _this.props.resources.YourPasswordCouldNotBeReset_1,
                        React.createElement("a", { href: '#', onClick: Services_1.Auth.reAuthenticateAfterPasswordReset }, _this.props.resources.ClickHere_LowerCase),
                        _this.props.resources.YourPasswordCouldNotBeReset_2,
                        React.createElement("a", { href: "mailto:verilite.support@reply.com?Subject=Password%20reset%20error&Body=The%20following%20error%20was%20recieved%20while%20trying%20to%20complete%20a%20password%20reset:%0D%0A" + encodeURI(Services_1.Auth.getError()), target: "_top" }, _this.props.resources.VeriLiteSupportEmail));
                case PasswordResetStatus.Canceled:
                    return React.createElement("span", null,
                        _this.props.resources.Please,
                        " ",
                        React.createElement("a", { href: '#', onClick: Services_1.Auth.reAuthenticateAfterPasswordReset }, _this.props.resources.ClickHere_LowerCase),
                        " ",
                        _this.props.resources.ToReturn,
                        ".");
                case PasswordResetStatus.Success:
                    return React.createElement("span", null,
                        _this.props.resources.PasswordHasBeenReset,
                        React.createElement("a", { href: '#', onClick: Services_1.Auth.reAuthenticateAfterPasswordReset }, _this.props.resources.SignIn_LowerCase),
                        _this.props.resources.ToContinue);
            }
        };
        _this.state = {
            status: Services_1.Auth.hasError ? Services_1.Auth.getError().startsWith("AADB2C90091") ? PasswordResetStatus.Canceled : PasswordResetStatus.Error : PasswordResetStatus.Success
        };
        return _this;
    }
    PasswordResetLanding.prototype.componentDidMount = function () {
        if (this.state.status == PasswordResetStatus.Success) {
            Services_1.postJson(Endpoints_1.default.SetUserPasswordResetFalse + "?id=" + Services_1.Auth.getUser().id, "");
        }
    };
    PasswordResetLanding.prototype.render = function () {
        return (React.createElement("div", null,
            React.createElement(reactstrap_1.Jumbotron, { fluid: true },
                React.createElement(reactstrap_1.Container, { fluid: true },
                    React.createElement("h1", { className: "display-3" }, this.title()),
                    React.createElement("p", { className: "lead" }, this.content())))));
    };
    return PasswordResetLanding;
}(React.Component));
exports.PasswordResetLanding = PasswordResetLanding;
//# sourceMappingURL=PasswordResetLanding.js.map